import { ComponentType } from "react";

export const UnderdotsLogoHorizontalBlackGreen: ComponentType = () => {
  return (
    <svg
      width="300"
      height="42"
      viewBox="0 0 1010 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M134.86 73.8898V32.0898H152.9V72.4798C152.9 86.1998 159.27 95.0498 175.26 95.0498C191.25 95.0498 197.51 86.1898 197.51 72.4798V32.0898H215.55V73.8898C215.55 96.3498 202.16 110.83 175.27 110.83C148.38 110.83 134.88 96.3598 134.88 73.8898H134.86Z"
        fill="#282828"
      />
      <path
        d="M315.87 109.64H299.99L251.61 55.0998V109.64H234.11V32.0898H252.36L298.37 84.0398V32.0898H315.87V109.64Z"
        fill="#282828"
      />
      <path
        d="M336.28 32.0898H376.46C404 32.0898 421.28 47.2098 421.28 70.8598C421.28 94.5098 404 109.63 376.46 109.63H336.28V32.0898ZM376.46 94.4098C393.31 94.4098 403.14 85.1198 403.14 70.8698C403.14 56.6198 393.31 47.3298 376.36 47.3298H354V94.4198H376.46V94.4098Z"
        fill="#282828"
      />
      <path
        d="M631.42 32.0898H671.6C699.14 32.0898 716.42 47.2098 716.42 70.8598C716.42 94.5098 699.14 109.63 671.6 109.63H631.42V32.0898ZM671.6 94.4098C688.45 94.4098 698.28 85.1198 698.28 70.8698C698.28 56.6198 688.45 47.3298 671.5 47.3298H649.14V94.4198H671.6V94.4098Z"
        fill="#282828"
      />
      <path
        d="M822.08 70.8702C822.08 93.9802 802.75 110.83 776.07 110.83C749.39 110.83 729.95 93.9802 729.95 70.8702C729.95 47.7602 749.28 30.9102 776.07 30.9102C802.86 30.9102 822.08 47.7602 822.08 70.8702ZM748.31 70.8702C748.31 85.5602 759.87 95.1702 776.07 95.1702C792.27 95.1702 803.72 85.5602 803.72 70.8702C803.72 56.1802 792.16 46.5702 776.07 46.5702C759.98 46.5702 748.31 56.1802 748.31 70.8702Z"
        fill="#282828"
      />
      <path
        d="M880.58 47.5396V109.64H862.54V47.5396H828.84V32.0996H914.16V47.5396H880.57H880.58Z"
        fill="#282828"
      />
      <path
        d="M929.48 81.4502C938.55 92.1402 952.38 95.7102 963.61 95.7102C975.6 95.7102 984.02 92.4702 984.02 86.8502C984.02 80.3702 977.65 79.8302 956.91 77.5602C938.44 75.5102 923.54 71.7302 923.54 56.1802C923.54 40.6302 938.34 30.9102 960.8 30.9102C978.3 30.9102 993.85 36.7402 1001.19 45.2702L989.85 57.2602C983.69 50.1302 972.46 45.9202 959.61 45.9202C946.76 45.9202 941.25 49.5902 941.25 54.2402C941.25 59.3202 946.65 60.4002 965.77 62.5602C986.07 64.8302 1002.71 67.9602 1002.71 84.9202C1002.71 101.88 985.65 110.84 962.86 110.84C945.04 110.84 925.92 104.47 918.15 94.5302L929.49 81.4602L929.48 81.4502Z"
        fill="#282828"
      />
      <path
        d="M438.63 109.64H513.8V94.1898H456.34V77.6698H513.8V62.4398H456.34V47.5398H513.8V32.0898H438.63V109.64Z"
        fill="#282828"
      />
      <path
        d="M612.22 100.15L595.64 80.2598C606.55 76.7998 613.14 68.6998 613.14 57.0398C613.14 40.8398 601.05 32.0898 583.01 32.0898H533.65V109.63H551.69V82.0898H576.49L599.76 109.63H612.22V100.14V100.15ZM582.03 67.4098H551.68V47.3198H582.03C590.56 47.3198 595.42 50.9898 595.42 57.3598C595.42 63.7298 590.56 67.3998 582.03 67.3998V67.4098Z"
        fill="#282828"
      />
      <path
        d="M74.1801 50.5596C74.7401 52.9996 75.0401 55.5396 75.0401 58.1396C75.0401 76.8496 59.8701 92.0196 41.1601 92.0196C38.5501 92.0196 36.0201 91.7196 33.5801 91.1596C37.0301 106.22 50.5001 117.46 66.6001 117.46C85.3101 117.46 100.48 102.29 100.48 83.5796C100.48 67.4796 89.2401 54.0096 74.1801 50.5596Z"
        fill="#A6E200"
      />
      <path
        d="M66.6003 49.6998C69.2103 49.6998 71.7403 49.9998 74.1803 50.5598C70.7303 35.4998 57.2603 24.2598 41.1603 24.2598C22.4503 24.2598 7.28027 39.4298 7.28027 58.1398C7.28027 74.2398 18.5203 87.7098 33.5803 91.1598C33.0203 88.7198 32.7203 86.1798 32.7203 83.5798C32.7203 64.8698 47.8903 49.6998 66.6003 49.6998Z"
        fill="#A6E200"
      />
    </svg>
  );
};

export const UnderdotsIconGreen: ComponentType<{
  className?: string;
}> = ({ className = "h-6 w-6" }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 284 284"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M202.6 80.8599C204.27 88.1699 205.19 95.7799 205.19 103.6C205.19 159.7 159.71 205.18 103.6 205.18C95.7799 205.18 88.1799 204.27 80.8599 202.59C91.1899 247.74 131.58 281.44 179.86 281.44C235.96 281.44 281.44 235.96 281.44 179.86C281.44 131.58 247.74 91.1899 202.59 80.8599H202.6Z"
        fill="#A6E200"
      />
      <path
        d="M179.86 78.28C187.68 78.28 195.28 79.19 202.6 80.87C192.27 35.71 151.88 2.02002 103.6 2.02002C47.5 2.02002 2.02002 47.5 2.02002 103.6C2.02002 151.88 35.72 192.27 80.87 202.6C79.2 195.29 78.28 187.68 78.28 179.86C78.28 123.76 123.76 78.28 179.86 78.28Z"
        fill="#A6E200"
      />
    </svg>
  );
};
